import { render } from "./Bookmark.vue?vue&type=template&id=6ae69584&scoped=true"
import script from "./Bookmark.vue?vue&type=script&lang=js"
export * from "./Bookmark.vue?vue&type=script&lang=js"

import "./Bookmark.vue?vue&type=style&index=0&id=6ae69584&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ae69584"

export default script